import { Route, Routes } from 'react-router-dom';
import About from './About';
import './App.css';
import Home from './Home';
// import NavBar from './NavBar';

function App() {
  return (
    <div className="App">


      {/* <NavBar/> */}

     <div className=' '> 
        <Routes>
          <Route path='home' element={<Home/>} />
          <Route path='about' element={<About/>} />
        </Routes>
     </div>

      {/* <Footer/> */}

    </div>
  );
}

export default App;
